import * as AC from './actionTypes';

export const getCustomers = (filters = {}) => ({
  type: AC.GET_CUSTOMERS_REQUEST,
  filters,
});

export const getCustomersByBuilding = (buildingId, filters = {}) => ({
  type: AC.GET_BUILDING_CUSTOMERS_REQUEST,
  buildingId,
  filters,
});

export const getCustomersByEntrance = (entranceId, filters = {}) => ({
  type: AC.GET_ENTRANCE_CUSTOMERS_REQUEST,
  entranceId,
  filters,
});

export const getCustomersBySite = (siteCode, siteNo, filters = {}) => ({
  type: AC.GET_CUSTOMERS_BY_SITE_REQUEST,
  siteCode,
  siteNo,
  filters,
});

export const getCustomersByCode = (code, filters = {}) => ({
  type: AC.GET_CUSTOMERS_BY_CODE_REQUEST,
  code,
  filters,
});

export const getCustomerDetails = id => ({
  type: AC.GET_CUSTOMER_DETAILS_REQUEST,
  id,
});

export const addCustomer = (
  email,
  firstName,
  lastName,
  birthday,
  flatNumber,
  entranceId,
  phoneNumber,
  identificationCard,
  contract,
  buildingId,
) => ({
  type: AC.ADD_CUSTOMER_REQUEST,
  payload: {
    email,
    firstName,
    lastName,
    birthday,
    flatNumber,
    entranceId,
    phoneNumber,
    identificationCard,
    contract,
  },
  buildingId,
});

export const editCustomer = (
  email,
  firstName,
  lastName,
  birthday,
  flatNumber,
  entranceId,
  phoneNumber,
  identificationCard,
  contract,
  buildingId,
  id,
) => ({
  type: AC.EDIT_CUSTOMER_REQUEST,
  payload: {
    email,
    firstName,
    lastName,
    birthday,
    flatNumber,
    entranceId,
    phoneNumber,
    identificationCard,
    contract,
    buildingId,
    id,
  },
});

export const deleteCustomer = id => ({
  type: AC.DELETE_CUSTOMER_REQUEST,
  id,
});

export const addNote = (customerId, note) => ({
  type: AC.ADD_NOTE_REQUEST,
  payload: {
    customerId,
    note,
  },
});

export const getNotes = customerId => ({
  type: AC.GET_NOTES_REQUEST,
  customerId,
});
